import React from 'react'
import createUserInCompanyMutation from 'graphs/mutations/createUserInCompany.graphql'
import userValidation from 'validations/user'
import FormForRecord from 'components/FormForRecord'
import userFields from 'fields/users'

const RouteCompaniesUsersNew = ({ history: { goBack }, company, ...rest }) => (
  <FormForRecord
    mutation={createUserInCompanyMutation}
    onSuccess={goBack}
    onCancel={goBack}
    fields={userFields}
    variables={{ company_id: company.id }}
    schema={userValidation}
    title={`Create A User for ${company.name}`}
    {...rest}
  />
)

export default RouteCompaniesUsersNew



// WEBPACK FOOTER //
// ./src/routes/admin/companies/users/new.js